import { getCurrentUser as apiGetCurrentUser, logoutUser as apiLogoutUser } from '../api';
import firebaseAuthService from './firebaseAuth';

export const getCurrentUser = async () => {
  return apiGetCurrentUser();
};

export const logoutUser = async () => {
  // Sign out from Firebase
  try {
    await firebaseAuthService.signOut();
  } catch (error) {
    console.error('Firebase sign out error:', error);
  }
  
  // Clear local token
  apiLogoutUser();
};
